import {IABTestConfiguration, IVariantConfigParams} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

export enum OngoingABTests {
    MULTI_LEAD_SUMMARY = "MULTI_LEAD_SUMMARY",
    OPINIONS_USER_INTEREST = "OPINIONS_USER_INTEREST",
    HIDE_PRICES_AND_REGISTER = "HIDE_PRICES_AND_REGISTER"
}

/**
 * Hidden prices - in the future, tests will probably be restored (in some form), below is the MR that removed that test.
 * @see https://git.rynekpierwotny.com/propertygroup/mono/-/merge_requests/3606
 */

export enum HidePricesVariant {
    VISIBLE = 0,
    HIDDEN = 1,
    VISIBLE_WITH_COMPLETE_PROFILE = 2
}

/**
 * Example of a test configuration:
 * {
 *     id: "xyz123" // Generated id, received from business,
 *     expires: new Date(2024, 3, 30), // Date when the test will expire,
 *     name: OngoingABTests.SOME_FEATURE, // Name of the test,
 *     path: ["some-path"], // Paths where the test will be active,
 *     matchOnAllPaths: false, // If true, the test will be active on all paths,
 *     sampleRate: 1, // Percentage of users that will be included in the test (0.0 - 1.0)
 *     variants: 3, // Number of variants, the actual amount is variants + 1 (first variant is 0)
 *     withSSR: false // If true, the test will be active on server side rendering
 * }
 */

export const ongoingABTests: IABTestConfiguration[] = [
    {
        id: "Yy99k333zk71O3b0bG1y",
        expires: new Date(2025, 9, 1),
        name: OngoingABTests.MULTI_LEAD_SUMMARY,
        path: [],
        matchOnAllPaths: true,
        variants: 2,
        withSSR: false
    },
    {
        id: "zxIMyz207kz7og0ulmkq",
        expires: new Date(2025, 3, 30),
        name: OngoingABTests.OPINIONS_USER_INTEREST,
        path: [rpAppPath.offer.detail.base, rpAppPath.property.detail.base],
        variants: 1,
        withSSR: false
    },
    {
        id: "n77o071117kz00mmttoi",
        expires: new Date(2026, 0, 31),
        name: OngoingABTests.HIDE_PRICES_AND_REGISTER,
        path: [],
        matchOnAllPaths: true,
        variantConfig: ({isAuthenticated, hasCompleteProfile}: IVariantConfigParams) => {
            if (isAuthenticated && hasCompleteProfile) {
                return {
                    [HidePricesVariant.VISIBLE_WITH_COMPLETE_PROFILE]: 1.0,
                    [HidePricesVariant.VISIBLE]: 0,
                    [HidePricesVariant.HIDDEN]: 0
                }; // 100% visible prices for authenticated users with complete profile
            }

            return {
                [HidePricesVariant.VISIBLE]: 0.6,
                [HidePricesVariant.HIDDEN]: 0.4,
                [HidePricesVariant.VISIBLE_WITH_COMPLETE_PROFILE]: 0
            }; // 80% visible, 20% hidden for unauthenticated users, HIDDEN_WITH_UNLOCK is set programmatically
        },
        variants: 2,
        withSSR: true
    }
];
import {IABTestConfiguration, IVariantConfigParams} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

export enum OngoingABTests {
    MULTI_LEAD_SUMMARY = "MULTI_LEAD_SUMMARY",
    OPINIONS_USER_INTEREST = "OPINIONS_USER_INTEREST",
    HIDE_PRICES_AND_REGISTER = "HIDE_PRICES_AND_REGISTER"
}

/**
 * Hidden prices - in the future, tests will probably be restored (in some form), below is the MR that removed that test.
 * @see https://git.rynekpierwotny.com/propertygroup/mono/-/merge_requests/3606
 */

export enum HidePricesVariant {
    VISIBLE = 0,
    HIDDEN = 1,
    VISIBLE_WITH_COMPLETE_PROFILE = 2
}

/**
 * Example of a test configuration:
 * {
 *     id: "xyz123" // Generated id, received from business,
 *     expires: new Date(2024, 3, 30), // Date when the test will expire,
 *     name: OngoingABTests.SOME_FEATURE, // Name of the test,
 *     path: ["some-path"], // Paths where the test will be active,
 *     matchOnAllPaths: false, // If true, the test will be active on all paths,
 *     sampleRate: 1, // Percentage of users that will be included in the test (0.0 - 1.0)
 *     variants: 3, // Number of variants, the actual amount is variants + 1 (first variant is 0)
 *     withSSR: false // If true, the test will be active on server side rendering
 * }
 */

export const ongoingABTests: IABTestConfiguration[] = [
    {
        id: "Yy99k333zk71O3b0bG1y",
        expires: new Date(2025, 9, 1),
        name: OngoingABTests.MULTI_LEAD_SUMMARY,
        path: [],
        matchOnAllPaths: true,
        variants: 2,
        withSSR: false
    },
    {
        id: "zxIMyz207kz7og0ulmkq",
        expires: new Date(2025, 3, 30),
        name: OngoingABTests.OPINIONS_USER_INTEREST,
        path: [rpAppPath.offer.detail.base, rpAppPath.property.detail.base],
        variants: 1,
        withSSR: false
    },
    {
        id: "n77o071117kz00mmttoi",
        expires: new Date(2026, 0, 31),
        name: OngoingABTests.HIDE_PRICES_AND_REGISTER,
        path: [],
        matchOnAllPaths: true,
        variantConfig: ({isAuthenticated, hasCompleteProfile}: IVariantConfigParams) => {
            if (isAuthenticated && hasCompleteProfile) {
                return {
                    [HidePricesVariant.VISIBLE_WITH_COMPLETE_PROFILE]: 1.0,
                    [HidePricesVariant.VISIBLE]: 0,
                    [HidePricesVariant.HIDDEN]: 0
                }; // 100% visible prices for authenticated users with complete profile
            }

            return {
                [HidePricesVariant.VISIBLE]: 0.6,
                [HidePricesVariant.HIDDEN]: 0.4,
                [HidePricesVariant.VISIBLE_WITH_COMPLETE_PROFILE]: 0
            }; // 80% visible, 20% hidden for unauthenticated users, HIDDEN_WITH_UNLOCK is set programmatically
        },
        variants: 2,
        withSSR: true
    }
];
